import React from 'react'

function MainTitle({ title }) {
  return (
    <h1 className='mainTitle'>{ title }</h1>
  )
}

export default MainTitle